export default "__VITE_ASSET__PG$Xc1e$__"